assumeImmutableResults